<template>
  <div
    class="good_detail"
    v-loading="spuLoading"
    :element-loading-text="$t('product.loading')"
  >
    <div v-if="spuInfo && spuInfo.spuId">
      <!-- 类别显示 -->
      <div class="good_category">
        <div class="good_category_content home_page">
          <div>
            <el-breadcrumb
              separator="/"
              v-if="spuInfo"
              style="line-height: 48px"
            >
              <el-breadcrumb-item :to="{ name: `selectionCategoryList` }"
                >产品选型</el-breadcrumb-item
              >
              <el-breadcrumb-item
                v-for="item in spuInfo.categoryChain"
                :key="item.id"
                :to="{
                  name: `selectionCategoryList`,
                  query: {
                    foregroundCategoryId: item.id,
                  },
                }"
                >{{ item.name }}</el-breadcrumb-item
              >
              <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="cusService">
            <a @click="$consultJump($store.state.user)" class="consult">
              <img
                src="~@/assets/img/cusService.png"
                alt=""
                class="img_cusService"
              />
              联系客服
            </a>
          </div>
        </div>
      </div>
      <div class="detail_content home_page">
        <!-- 商品spu或sku信息显示 -->
        <div class="good_spku_info">
          <div class="good_info_imgs flex-shrink">
            <div style="width: 400px; height: 400px; line-height: 400px">
              <goodImg
                v-if="
                  currentSkuInfo &&
                  currentSkuInfo.fileUrlList &&
                  currentSkuInfo.fileUrlList.length &&
                  currentSkuInfo.fileUrlList[mainGraphIndex]
                "
                :img="
                  currentSkuInfo &&
                  currentSkuInfo.fileUrlList &&
                  currentSkuInfo.fileUrlList.length &&
                  currentSkuInfo.fileUrlList[mainGraphIndex]
                "
              ></goodImg>
              <img v-else src="@/assets/img/bitmap.png" alt="" width="400px" />
            </div>
            <!-- 图片轮播图 -->
            <div
              class="img-carousel"
              v-show="
                currentSkuInfo &&
                currentSkuInfo.fileUrlList &&
                currentSkuInfo.fileUrlList.length
              "
            >
              <el-carousel
                indicator-position="none"
                height="60px"
                v-if="currentSkuInfo && currentSkuInfo.fileUrlList"
              >
                <el-carousel-item
                  v-for="(i, ind) in Math.ceil(
                    currentSkuInfo.fileUrlList.length / 5
                  )"
                  :key="ind"
                >
                  <div class="imgs-row">
                    <img
                      :src="item"
                      alt="商品主图"
                      width="60px"
                      height="60px"
                      v-for="(item, index) in currentSkuInfo.fileUrlList.slice(
                        ind * 5,
                        ind * 5 + 5
                      )"
                      :key="index"
                      @click="changeShowImg(ind * 5 + index)"
                      class="img_left"
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="good_info_content flex-grow">
            <div class="good_spku_info">
              <div class="good_title_dec flex-grow">
                <!-- sku 标题-->
                <div class="good_title line-break">
                  {{ currentSkuInfo.title }}
                </div>
                <div class="good_dec line-break">
                  {{ spuInfo.subtitle }}
                </div>
              </div>
              <div
                class="good_brand flex-shrink text-center"
                v-if="spuInfo.brandLogoInfo"
              >
                <img
                  :src="spuInfo.brandLogoInfo.fileUrl || ''"
                  :alt="spuInfo.brandLogoInfo.name"
                  class="cursor-pointer fit-contain"
                  @click="brandHandle(spuInfo.brandLogoInfo.brandId)"
                  height="90px"
                />
                <div class="text-center">{{ spuInfo.brandLogoInfo.name }}</div>
              </div>
            </div>
            <el-row>
              <el-col :span="24">
                <div class="good-flex" v-show="currentSkuInfo.sellingUnit">
                  <label class="lable flex-shrink"
                    >{{ $t("common.unit") }}：</label
                  >
                  <div class="flex-grow good-models">
                    {{ currentSkuInfo.sellingUnit }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="good-flex" v-show="currentSkuInfo.deliveryTime">
                  <label class="lable flex-shrink">供货周期(工作日)：</label>
                  <div class="flex-grow good-models">
                    {{ currentSkuInfo.deliveryTime }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="good-flex" v-show="currentSkuInfo.moq">
                  <label class="lable flex-shrink">最小起订量：</label>
                  <div class="flex-grow good-models">
                    {{ currentSkuInfo.moq }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="good-flex" v-show="spuInfo">
                  <label class="lable flex-shrink">{{
                    $t("product.productNo")
                  }}</label>
                  <div class="flex-grow good-models">
                    {{ spuInfo.supplyCommodityCode }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div
                  class="good-flex"
                  v-show="
                    spuInfo.serviceGuaranteesTypeList &&
                    spuInfo.serviceGuaranteesTypeList.length
                  "
                >
                  <label class="lable flex-shrink">{{
                    $t("product.service")
                  }}</label>
                  <div class="flex-grow good-services">
                    <div
                      class="service"
                      v-for="item in spuInfo.serviceGuaranteesTypeList"
                      :key="item"
                    >
                      <i class="el-icon-circle-check icon-color"></i>
                      {{ item }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="handle-box">
              <!-- 数量加减器 -->
              <div v-show="commodityType < 3 || commodityType === 4">
                <div class="flex-grow">
                  <el-tooltip
                    placement="top"
                    :content="`起订量${currentSkuInfo.moq || 1}, 步长${
                      currentSkuInfo.sellingUnitStepSize || 1
                    }`"
                  >
                    <span>
                      <el-input-number
                        size="small"
                        :disabled="loading"
                        v-model="count"
                        :step="1"
                        :min="1"
                        :max="999999999"
                        :precision="0"
                      ></el-input-number></span
                  ></el-tooltip>
                </div>
              </div>
              <!-- 加购按钮 -->
              <div class="bottom">
                <div class="good-opt">
                  <el-button
                    class="buy-imm"
                    @click="addLectotype('create')"
                    :loading="loading"
                    >立即询价</el-button
                  >
                  <el-button
                    class="add-cart"
                    @click="addLectotype('cart')"
                    :loading="loading"
                    >加入询价篮</el-button
                  >
                </div>
              </div>
            </div>
            <!-- 配置选型 -->
            <div class="spu_attr">
              <div class="spu_attr_title">
                <div class="spu_attr_title_left">配置选型：</div>
                <div class="spu_attr_title_right">
                  参数列表
                  <img
                    width="24px"
                    :src="require('@/assets/img/list-active.png')"
                    v-if="attrMode === 1"
                  />
                  <img
                    width="24px"
                    :src="require('@/assets/img/list.png')"
                    @click="attrMode = 1"
                    v-else
                  />
                  <img
                    width="24px"
                    :src="require('@/assets/img/table-active.png')"
                    v-if="attrMode === 2"
                  />
                  <img
                    width="24px"
                    :src="require('@/assets/img/table.png')"
                    @click="attrMode = 2"
                    v-else
                  />
                </div>
              </div>
              <!-- 属性选择框 -->
              <div class="spu_attr_list">
                <ul class="attr-list" v-show="attrMode === 1">
                  <li
                    v-for="item in attributeGroupItemList"
                    :key="item.attributeItemId"
                  >
                    <!-- 属性名 -->
                    <span class="attr-item-name">{{ item.name }}：</span>
                    <!-- 属性选择 -->
                    <div
                      class="attr-item-wrap"
                      :class="{
                        attrEmpty: item.attributeValueList.every(
                          (attr) => attr.attributeValueId !== item.checkedId
                        ),
                      }"
                    >
                      <div
                        v-for="zItem in item.attributeValueList"
                        :key="zItem.attributeValueId"
                        class="attr-item cursor-pointer"
                        :class="{
                          selected: item.checkedId === zItem.attributeValueId,
                          inputed: zItem.name === '手动录入',
                        }"
                        @click="selectAttributeItem(zItem, item)"
                      >
                        <el-input
                          v-if="zItem.name === '手动录入'"
                          size="mini"
                          clearable
                          v-model.trim="zItem.selectedAttributeValueName"
                          maxlength="255"
                          placeholder="手动录入"
                        />
                        <template v-else>
                          {{ zItem.name }}
                        </template>
                      </div>
                    </div>
                  </li>
                </ul>
                <div
                  v-show="attrMode === 1 && attributeGroupItemList.length === 0"
                >
                  暂无数据
                </div>
                <el-table
                  v-show="attrMode === 2"
                  :data="attributeGroupItemList"
                  border
                  class="attr-table"
                  height="330px"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    label="属性名称"
                    min-width="80"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="attributeValueName"
                    label="属性值"
                    min-width="180"
                  >
                    <template slot-scope="scope">
                      <el-select
                        :class="{ attrEmpty: !scope.row.checkedId }"
                        v-model="scope.row.checkedId"
                        @change="selectAttributeItem"
                        clearable
                      >
                        <template slot="prefix">
                          <el-input
                            @click.stop.native
                            v-if="
                              scope.row.attributeValueList.find(
                                (item) =>
                                  item.attributeValueId === scope.row.checkedId
                              ) &&
                              scope.row.attributeValueList.find(
                                (item) =>
                                  item.attributeValueId === scope.row.checkedId
                              ).name === '手动录入'
                            "
                            size="mini"
                            clearable
                            v-model.trim="
                              scope.row.attributeValueList.find(
                                (item) =>
                                  item.attributeValueId === scope.row.checkedId
                              ).selectedAttributeValueName
                            "
                            maxlength="255"
                            placeholder="手动录入"
                            class="manualInput"
                          />
                        </template>
                        <el-option
                          v-for="item in scope.row.attributeValueList"
                          :key="item.attributeValueId"
                          :value="item.attributeValueId"
                          :label="item.name"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <!-- 搭配型号 -->
        <div class="match-model" v-show="correlativeSpuInfoList.length">
          <el-tabs type="border-card" style="width: 100%">
            <el-tab-pane>
              <span slot="label">搭配型号</span>
              <el-carousel
                :interval="5000"
                arrow="always"
                height="250px"
                v-if="correlativeSpuInfoList.length"
              >
                <el-carousel-item
                  v-for="(i, idx) in Math.ceil(
                    correlativeSpuInfoList.length / 5
                  )"
                  :key="idx"
                >
                  <!-- <h3>{{ item }}</h3> -->
                  <div class="collocation">
                    <div
                      class="collocation-good"
                      v-for="item in correlativeSpuInfoList.slice(
                        idx * 5,
                        idx * 5 + 5
                      )"
                      :key="item.correlativeSpuId"
                      @click="choosedSpuId(item)"
                    >
                      <img
                        :src="item.fileUrl"
                        alt=""
                        width="178px"
                        height="178px"
                      />
                      <div class="collocation-good-name ellipsis">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 商品详情相关信息 -->
        <div class="good_spku_info">
          <el-tabs type="border-card" style="width: 100%">
            <el-tab-pane>
              <span slot="label">{{ $t("product.detail") }}</span>
              <div class="line-break good_spu_detail">
                <div
                  v-for="detailInfo in allDetailInfo"
                  :key="detailInfo.type"
                  class="detail-item"
                >
                  <template v-if="detailInfo.name && detailInfo.paraText">
                    <div class="good-detail-title">
                      <div class="name">{{ detailInfo.name }}</div>
                    </div>
                    <div class="content" v-html="detailInfo.paraText"></div>
                  </template>
                </div>
              </div>
              <!-- <div v-html="spuDetailInfo"
                   class="line-break good_spu_detail"></div> -->
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">{{ $t("product.relatedParameters") }}</span>
              <div
                v-for="optionItem in attributeGroupList"
                :key="optionItem.attributeGroupId"
                class="groupParams"
              >
                <div class="model-params-name">
                  {{ optionItem.name }}
                </div>
                <div
                  v-for="attItem in optionItem.attributeItemList"
                  :key="attItem.attributeItemId"
                  class="attList"
                >
                  <div class="att-name">{{ attItem.name }}</div>
                  <div class="att-value">
                    {{ attItem.attributeValueList | formatAtt }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane>
              <span slot="label">{{ $t("product.manualBook") }}</span>
              <div
                v-if="currentSkuInfo && currentSkuInfo.manualFile"
                @click="viewAttachment(currentSkuInfo.manualFile.fileUrl)"
                class="attachment"
              >
                {{ currentSkuInfo.manualFile.fileName || currentSkuInfo.title }}
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="good_spku_info">
          <div
            style="
              width: 100%;
              height: 46px;
              background: #f5f5f5;
              border: 1px solid #dedede;
              font-size: 18px;
              color: #333;
              line-height: 46px;
              padding-left: 20px;
            "
          >
            {{ $t("product.noteTitle") }}
          </div>
        </div>
        <div class="good_spku_info" style="margin-top: 0">
          <div
            style="
              width: 100%;
              border: 1px solid #dedede;
              font-size: 14px;
              color: #333;
              padding: 20px;
              border-top: none;
            "
          >
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title1") }}：</span
              >{{ $t("product.content1") }}
            </div>
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title2") }}：</span
              >{{ $t("product.content2") }}
            </div>
            <div style="color: #666; margin-bottom: 8px">
              <span style="font-weight: bold">{{ $t("product.title3") }}：</span
              >{{ $t("product.content3") }}
            </div>
            <div style="color: #666">
              <span style="font-weight: bold">{{ $t("product.title4") }}：</span
              >{{ $t("product.content4") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_page" v-else>
      <div class="no_show_message">
        <img src="@/assets/img/good/noGood.png" :alt="$t('product.loading')" />
        <!-- <div>努力加载中</div> -->
      </div>
    </div>
    <company-add
      ref="companyAdd"
      v-if="addCompanyVisible"
      :jumpRoute="false"
    ></company-add>
    <SupportIcon />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import CountDown from '@/components/count-down'
import GoodPrice from '@/components/good-price'
import goodImg from '@/components/img'
import { openOther } from '@/utils'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
import SupportIcon from './components/supportIcon.vue'
export default {
  data () {
    return {
      attrMode: 1, // 切换视图
      loading: false,
      spuLoading: false,
      spuInfo: null,
      correlativeSpuInfoList: [], // 搭配型号,
      attributeGroupList: [], // 参数项
      skuInfoList: [], // sku列表
      spuDetailInfo: '', // 商品详情
      count: 1,
      mainGraphIndex: 0, // 主图索引
      addCompanyVisible: false, // 企业账号 dialog
      allDetailInfo: [],
      changeAble: false,

      attributeGroupItemList: [], // 属性组内所有属性项
      attributeItemActive: null, // 选中属性的下标
      attributeValueAllList: [], // 选中属性下的属性值组
      attributeValueIdSelecteds: [], // 所有选中的属性值id
      frontHide: [] // 未展示的属性
    }
  },
  components: {
    CountDown,
    GoodPrice,
    goodImg,
    SupportIcon,
    CompanyAdd
  },
  computed: {
    spuId () {
      return this.$route.query.spuId
    },
    skuId () {
      return this.$route.query.skuId
    },
    currentSkuInfo () {
      let currentSku = {
        fileUrlList: []
      }
      let fileUrlList = this.spuInfo
        ? JSON.parse(JSON.stringify(this.spuInfo.fileUrlList)) || []
        : []

      // 选型商品 没有sku只有spu
      currentSku = {
        ...this.spuInfo,
        title: this.spuInfo ? this.spuInfo.name : '',
        fileUrlList: fileUrlList
      }

      return currentSku
    },
    /**
     * 商品spu的类型
     * 1实物-标品 默认，
     * 2虚拟-标品
     * 3虚拟-非标询价品，可去询价 不可以加入询价篮
     * 4实物-非标询价品，可去询价
     */
    commodityType () {
      let type = 1
      if (this.spuInfo) {
        if (this.spuInfo.commodityType === '虚拟-标品') {
          type = 2
        } else if (this.spuInfo.commodityType === '虚拟-非标询价品') {
          type = 3
        } else if (this.spuInfo.commodityType === '实物-非标询价品') {
          type = 4
        }
      }
      return type
    }
  },
  watch: {
    spuId: {
      immediate: true,
      handler: 'getGoodInfo'
    },
    skuId (val) {
      this.count = 1
    }
  },
  filters: {
    formatAtt (att) {
      return att
        .map((item) => {
          return item.name
        })
        .join('、')
    }
  },
  created () {
    // 暂时性解决 app banner跳转商详显示问题
    // document.body.clientWidth
    if (this.$route.query.token) {
      Cookies.set('access_token_shop', this.$route.query.token)
    }
  },
  mounted () {},
  methods: {
    // 获取商品详情信息
    getGoodInfo () {
      if (!this.spuId) {
        return false
      }
      this.spuInfo = null
      this.correlativeSpuInfoList = []
      this.attributeGroupList = []
      this.attributeGroupItemList = []
      this.frontHide = []
      this.skuInfoList = []
      this.spuDetailInfo = ''
      this.spuLoading = true
      this.$request
        .get(`/front/cross/commodity-user/spu-detail/${this.spuId}`)
        .then((res) => {
          // { data: res }
          // console.log(res)
          this.spuInfo = res.spuInfo
          this.correlativeSpuInfoList = res.correlativeSpuInfoList
          this.attributeGroupList = (
            res.attribute ? res.attribute.attributeGroupList || [] : []
          ).map((item) => {
            return {
              ...item,
              // 过滤商品参数
              attributeItemList:
                (item.attributeItemList &&
                  item.attributeItemList.filter(
                    (item) => !(item.frontShow === false)
                  )) ||
                []
            }
          })
          // 合并所有的属性组内的属性(过滤严格等于false的frontShow属性)
          this.attributeGroupItemList = (
            res.attribute ? res.attribute.attributeItemList || [] : []
          )
            .filter((item) => !(item.frontShow === false))
            .map((item) => {
              return {
                ...item,
                checkedId: ''
              }
            })
          this.frontHide = (
            res.attribute ? res.attribute.attributeItemList || [] : []
          ).filter((item) => item.frontShow === false)
          this.skuInfoList = res.skuInfoList || []
          this.spuDetailInfo = res.spuDetailInfoForWeb || ''
          this.allDetailInfo = res.allDetailInfo || []
        })
        .finally(() => {
          this.spuLoading = false
        })
    },
    // 选择属性 多选
    selectAttributeGroup (item, index) {
      this.attributeItemActive = index
      this.attributeValueAllList = item.attributeValueList
    },
    // 选择属性值 单选
    selectAttributeItem (item, zItem) {
      if (zItem) {
        zItem.checkedId = item.attributeValueId
        // item.checkedId = item.checkedId ? '' : zItem.attributeValueId
      }
      this.attributeValueIdSelecteds = this.attributeGroupItemList
        .map((attrItem) => attrItem.checkedId)
        .filter((attrItem) => !!attrItem)
    },
    // 加入询价篮或者立即询价
    addLectotype (type) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.attributeValueIdSelecteds.length <= 0) {
        this.$message.warning('请选择对应的属性')
        return false
      }
      if (
        this.attributeValueIdSelecteds.length !==
        this.attributeGroupItemList.length
      ) {
        this.$message.warning('配置选型的所有项都必填')
        return false
      }
      // 判断是否有选中手动录入的项
      let manualAttributeValueList = []
      let manualFlag = false
      this.attributeValueIdSelecteds.forEach((item) => {
        const result = this.attributeGroupItemList.find(
          (attr) => attr.checkedId === item
        )
        if (result) {
          const childResult = result.attributeValueList.find(
            (attrItem) => attrItem.attributeValueId === item
          )
          if (childResult && childResult.name === '手动录入') {
            if (childResult.selectedAttributeValueName) {
              manualAttributeValueList.push({
                manualAttributeValueId: item,
                manualAttributeValue: childResult.selectedAttributeValueName
              })
            } else {
              manualFlag = true
            }
          }
        }
      })
      if (manualFlag) {
        this.$message.warning('请检查手动录入项')
        return
      }
      // 步长/起订量检验
      let { sellingUnitStepSize, title, moq } = this.currentSkuInfo
      !moq && (moq = 1)
      !sellingUnitStepSize && (sellingUnitStepSize = 1)
      if (this.count < +moq || this.count % sellingUnitStepSize !== 0) {
        this.$message.warning(
          `${title} 起订量为${
            moq || 1
          }，步长为${sellingUnitStepSize}，请输入大于${
            moq || 1
          }且${sellingUnitStepSize}的倍数！`
        )
        return
      }

      // 前台隐藏的属性，如果只有一个属性值，则默认选中带上
      const newAttributeValueIdSelecteds = JSON.parse(
        JSON.stringify(this.attributeValueIdSelecteds)
      )
      if (this.frontHide && this.frontHide.length) {
        this.frontHide.forEach((item) => {
          if (
            item.attributeValueList &&
            item.attributeValueList.length === 1 &&
            item.attributeValueList[0].attributeValueId
          ) {
            newAttributeValueIdSelecteds.push(
              item.attributeValueList[0].attributeValueId
            )
          }
        })
      }

      if (type === 'create') {
        // 跳转新建页面
        this.$router.push({
          name: 'selectionInquiryCreate',
          query: {
            inquiryInfo: JSON.stringify({
              goodsSpuId: this.spuId,
              goodsNum: this.count,
              attributeValueIds: newAttributeValueIdSelecteds,
              manualAttributeValueList: manualAttributeValueList
            })
          }
        })
      }

      if (type === 'cart') {
        if (this.loading) {
          return false
        }
        this.loading = true
        this.$http
          .post(`/front/commodity-user/web/lectotypeCart/add`, {
            goodsSpuId: this.spuId,
            goodsNum: this.count,
            attributeValueIds: newAttributeValueIdSelecteds,
            manualAttributeValueList: manualAttributeValueList
          })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$message.success(
              `${this.$t('product.add')} ${this.$t(
                'product.blanket'
              )} ${this.$t('product.success')}`
            )
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 更改主图的索引
    changeShowImg (index) {
      this.mainGraphIndex = index
    },
    // 点击搭配型号 更改spu
    choosedSpuId (item) {
      if (item.correlativeSpuId + '' === this.spuId) {
        return false
      }
      openOther(`goodDetail?spuId=${item.correlativeSpuId}&skuId=`)
    },
    // 查看附件
    viewAttachment (url) {
      if (url) {
        window.open(url)
      }
    },
    brandHandle (brandId) {
      if (!brandId) {
        return false
      }
      this.$router.push({
        name: 'goodBrandCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.good_detail {
  background: #fff;
  padding-bottom: 30px;
  .good-flex {
    margin-top: 16px;
    line-height: 20px;
    // letter-spacing: 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #555555;
    .lable {
      width: 125px;
    }
    .good-services {
      display: flex;
      .service {
        margin-right: 10px;
        // font-size: 10px;
        .icon-color {
          color: #2e88ff;
        }
      }
    }
  }
  .good_category {
    background: #f2f2f2;
    .good_category_content {
      display: flex;
      justify-content: space-between;
      color: #262727;
      line-height: 48px;
      font-size: 16px;
      font-size: 400;
      .cusService {
        cursor: pointer;
        .img_cusService {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .handle-box {
    display: flex;
    align-items: center;
    margin: 16px 0;
    .bottom {
      .good-opt {
        margin-left: 20px;
        color: #fff;
        .buy-imm {
          min-width: 150px;
          border: none;
          background: linear-gradient(132deg, #f97300 8%, #d9271e);
          color: #fff;
        }
        .buy-inquiry {
          min-width: 150px;
          border: none;
          background: #1d65a8;
          color: #fff;
          &:hover {
            background: #134574;
          }
        }
        // 禁用
        .but_ban {
          background: #aaa;
          cursor: not-allowed;
        }
        .add-cart {
          min-width: 150px;
          border: none;
          background: linear-gradient(233deg, #f47205 -22%, #f5b014 94%);
          color: #fff;
        }
      }
    }
  }
  .detail_content {
    padding-top: 20px;
    .good_spku_info {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .good_brand {
        width: 120px;
        position: absolute;
        right: 0;
        right: 0;
      }
      .good_info_imgs {
        width: 400px;
        .img-carousel {
          margin-top: 32px;
          // height: 60px;
          .imgs-row {
            width: 100%;
            height: 60px;
            padding-left: 20px;
            padding-right: 20px;
            .img_left {
              object-fit: contain;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
        .good_sku_opt {
          margin-top: 21px;
          font-size: 16px;
          line-height: 22px;
          font-weight: 400;
          color: #555555;
        }
      }
      .good_info_content {
        margin-left: 10px;
        position: relative;
        width: calc(100% - 410px);
        // padding-bottom: 100px;
        .good_title_dec {
          margin-bottom: 20px;
          width: 650px;
          .good_title {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            line-height: 26px;
          }
          .good_dec {
            margin-top: 10px;
            font-size: 16px;
            font-weight: 400;
            color: #d92a2a;
            line-height: 22px;
          }
        }
        .group-buying {
          justify-content: space-between;
          padding-left: 13px;
          padding-right: 13px;
          font-size: 18px;
          color: #ffffff;
          line-height: 36px;
          background: linear-gradient(130deg, #ff6793 10%, #ff0c0c 100%);
        }
        .good-original-price {
          margin-top: 0;
          height: 70px;
          background: #f5f5f5;
          .original-price {
            font-size: 14px;
            font-weight: bold;
            color: #e64c3a;
            // letter-spacing: 4px;
            /deep/ .price {
              color: #f63721;
              display: inline-block;
              .price-int {
                font-size: 26px;
              }
              .price-point {
                font-size: 14px;
              }
            }
            .cross-price {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-decoration: line-through;
              text-align: left;
              color: #666666;
              line-height: 18px;
            }
            .activity-not-start {
              margin-left: 20px;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              // color: #666666;
              line-height: 18px;
            }
          }
        }
        .good-models {
          .good-model {
            margin-top: 10px;
            display: inline-block;
            margin-right: 10px;
            border: 1px solid #dedede;
            padding: 5px 15px;
            color: #333333;
            font-weight: 400;
            font-size: 14px;
            cursor: pointer;
          }
          .good-model-choosed {
            border-color: #2e88ff;
          }
        }
        .spu_attr {
          margin-top: 20px;
          padding-top: 12px;
          border-top: 1px solid #e1e3e6;

          .spu_attr_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .spu_attr_title_left {
              font-size: 20px;
              font-weight: bold;
              color: #1a1a1a;
            }

            .spu_attr_title_right {
              font-size: 14px;
              color: #969899;
              display: flex;
              align-items: center;

              img {
                margin-left: 8px;
                cursor: pointer;
              }
            }
          }

          .spu_attr_list {
            .attr-list {
              max-height: 330px;
              overflow: auto;

              li {
                display: flex;
                align-items: baseline;
                margin-bottom: 10px;

                &:last-child {
                  margin-bottom: 0;
                }

                .attr-item-name {
                  font-size: 16px;
                  font-weight: 500;
                  color: #646566;
                  white-space: nowrap;
                }

                .attr-item-wrap {
                  display: flex;
                  flex-wrap: wrap;
                  margin-left: 4px;

                  .attr-item {
                    border: 1px solid #969899;
                    padding: 4px 12px;
                    font-size: 14px;
                    line-height: 18px;
                    border-radius: 6px;
                    color: #646566;
                    margin-right: 12px;
                    margin-bottom: 6px;
                    overflow: hidden;

                    &.inputed {
                      padding: 0;
                      /deep/ .el-input__inner {
                        border: none;
                        height: 26px;
                        line-height: 26px;
                        padding: 0 12px;
                      }
                    }

                    &.selected {
                      color: #2a54d1;
                      border: 1px solid #2a54d1;
                      background: rgba(42, 84, 209, 0.1);
                    }
                  }
                }
              }
            }

            .attr-table {
              border-radius: 4px;

              /deep/ .el-table__header-wrapper {
                th.el-table__cell {
                  padding: 10px 0;
                  background: #f6f5fa;

                  & > .cell {
                    line-height: 19px;
                    color: #333;
                  }
                }
              }
              /deep/ .el-table__body-wrapper {
                td.el-table__cell {
                  padding: 0;

                  &:nth-child(2) {
                    & > .cell {
                      padding: 0;
                    }
                  }

                  & > .cell {
                    font-size: 14px;
                    color: #666666;

                    .el-select {
                      width: 100%;

                      input {
                        border: none;
                      }

                      .manualInput {
                        padding: 2px 0;
                        width: 200px;
                        input {
                          border: 1px solid #dcdfe6;
                          padding: 0 10px;
                          height: 36px;
                          line-height: 36px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .good_spu_detail {
        // overflow: hidden;
        max-width: 100%;
        /deep/ img {
          max-width: 100%;
        }
        .detail-item {
          .good-detail-title {
            height: 30px;
            border-bottom: 3px solid #468bd4;
            position: relative;
            margin-left: 16px;
            margin-bottom: 10px;
            &::before {
              content: " ";
              width: 12px;
              height: 30px;
              color: #468bd4;
              background: #468bd4;
              display: inline-block;
              position: absolute;
              left: -16px;
            }
            &::after {
              content: " ";
              width: 0;
              height: 0;
              display: inline-block;
              position: absolute;
              // left: 80px;
              border-bottom: 30px solid #468bd4;
              border-right: 30px solid transparent;
            }
            .name {
              float: left;
              background-color: #468bd4;
              color: #fff;
              font-weight: bold;
              font-size: 15px;
              height: 30px;
              line-height: 30px;
              padding: 0 10px;
              position: relative;
            }
          }
        }
      }
      .groupParams {
        border: 1px solid #eee;
        .model-params-name {
          padding: 12px 20px;
          font-size: 12px;
          line-height: 16px;
          color: #262727;
          font-weight: 500;
        }
        .attList {
          border-top: 1px solid #eee;
          display: flex;
          align-items: center;
          .att-name {
            padding: 10px;
            width: 30%;
            color: #999999;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            text-align: center;
            // flex-shrink: 1;
            // border-right: 1px solid #eee;
            flex-shrink: 0;
          }
          .att-value {
            // padding-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
            padding: 10px;
            border-left: 1px solid #eee;
          }
        }
      }
      .attachment {
        color: #2e88ff;
        cursor: pointer;
      }
    }
    .match-model {
      margin-top: 40px;
      .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        background: #f5f7fa;
        border: none;
        cursor: default;
      }
    }
    // 搭配型号
    .collocation {
      padding: 20px;
      display: flex;
      .collocation-good {
        width: 180px;
        text-align: center;
        img {
          border: none;
          border: 1px #eee dashed;
        }
        .collocation-good-name {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #333333;
          line-height: 24px;
        }
      }
      .space {
        margin-left: 60px;
      }
    }
  }

  .home_page {
    height: 100%;
  }
}
</style>
